import Api from "../../../../Api/Api";

const matrixApi = {
  bootstrap: () => Api.bootstrapMatrix(),
  getTraining: () => Api.getTrainingMatrix(),
  saveTraining: (payload) => Api.saveTrainingMatrix(payload),
  getJobCategories: () => Api.getJobCategoryMatrix(),
  saveJobCategories: (payload) => Api.saveJobCategoryMatrix(payload),
  exportCsv: (type) => Api.exportMatrix(type),
};

export default matrixApi;
